module.exports = __webpack_public_path__ + "img/logo_header.59c2de91.jpg";